export default __webpack_public_path__ + "static/media/D2022_07_24_Guadalajara.451a2b06.jpg";